module.exports = __webpack_public_path__ + "assets/img/u2.9d839d6f.png";